import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from "./pages/Login";
import Home from "./pages/Home";
import React, { useContext, useState, useEffect } from 'react';
import { AppContext, AppProvider } from './application/provider';
import DashboardLayout from './components/DashboardLayout/DashboardLayout';
import SideBar from './components/SideBar/SideBar';
import Prospectos from './pages/Prospectos';
import ProspectosTNP from './pages/ProspectosTNP';
import ChangePassword from './pages/ChangePassword';
import Reportes from './pages/Reportes';
import Usuarios from './pages/Usuarios';
import EstadoRevision from './pages/EstadoRevision';
import Agencias from './pages/Agencias';
import GestionProspectos from './pages/GestionProspectos';
import SolicitudesExtra from './pages/SolicitudesExtra';
import Avances from './pages/Avances';
import AsignacionMetas from './pages/AsignacionMetas';
import Planilla from './pages/Planilla';
import SimuladorCreditos from './pages/SimuladorPrestamos';
import Inventario from './pages/Inventario';
import CargoPago from './pages/CargoPago';
import AdministracionCargoPago from './pages/AdministracionCargoPago';
import GraficoDashboard from './pages/GraficoDashboard';
import DashboardAdministracion from './pages/DashboardAdministración';
import GraficosColocaciones from './pages/GraficoColocaciones';
import UsuarioService from './axios_services/usuarios.service';
import CatalogoService from './axios_services/catalogo.service';
import Loader from './components/Loader/Loader';
import { useNavigate } from 'react-router-dom';
import GastosTotales from './pages/GastosTotales';
import DetalleAbc from './pages/DetalleAbc';
import ReciboPorHonorarios from './pages/ReciboPorHonorarios';
import CostosDirectos from './pages/CostosDirectos';
import ResumenFinal from './pages/ResumenFinal';
import CostosAbc from './pages/CostosAbc';
import CajaFlujoDatos from './pages/CajaFlujoDatos';
import CajaFinancieroMovimiento from './pages/CajaFinancieroMovimiento';
import CajaFinancieroReporte from './pages/CajaFinancieroReporte';
import CajaFinancieroContabilidad from './pages/CajaFinancieroContabilidad';
import Viaticos from './pages/Viaticos';
import SolicitudViaticos from './pages/SolicitudViaticos';
import PlanillaViaticos from './pages/PlanillaViaticos';
import SeguimientoDesembolsos from './pages/SeguimientoDesembolsos';
import ComisionDesembolsos from './pages/ComisionDesembolsos';
import ControlPoi from './pages/ControlPoi';
import CajaFinancieroPresupuesto from './pages/CajaFinancieroPresupuesto';
import FirmaDigitalConvenios from './pages/FirmaDigitalConvenios';
import Perfil from './pages/Perfil';
import Notificaciones from './pages/Notificaciones';
import GestionCorreo from './pages/GestionCorreo';
import SesionesActivas from './pages/SesionesActivas';
import DispositivosConfianza from './pages/DispositivosConfianza';
import GestionServicioSistemas from './pages/GestionServicioSistemas';
import GestionExternoSistemas from './pages/GestionExternoSistemas';
import TareasGantt from './pages/TareasGantt';
import PagosPlanilla from './pages/PagosPlanilla';
import PapeletaSalida from './pages/PapeletaSalida';
import RendicionViaticos from './pages/RendicionViaticos';
import DescuentoTardanza from './pages/DescuentoTardanza';
import Capacitaciones from './pages/Capacitaciones';
import Asistencias from './pages/Asistencias';
import Induccion from './pages/Induccion';
import Practicantes from './pages/Practicantes';
import CesoCulminacionContrato from './pages/CesoCulminacionContrato';
import ValidacionServicio from './pages/ValidacionServicio';
import CulminacionVinculoLaboral from './pages/CulminacionVinculoLaboral';
import SeguimientoBoletaProspecto from './pages/SeguimientoBoletaProspecto';
import InduccionNegocios from './pages/InduccionNegocios';
import PersonalReclutamiento from './pages/PersonalReclutamiento';
import RHAdministracion from './pages/RHAdministracion';
import PlanillaNegocios from './pages/PlanillaNegocios';
import RhPracticantes from './pages/RhPracticantes';
import Memorandum from './pages/Memorandum';
import SueldosPlanilla from './pages/SueldosPlanilla';
import RestablecerProspectos from './pages/RestablecerProspectos';
import ReporteColaboradores from './pages/ReporteColaboradores';
import PagoDetracciones from './pages/PagoDetracciones';
import GestionProveedores from './pages/GestionProveedores';
import GestionServiciosProveedor from './pages/GestionServiciosProveedor';
import PagoProveedores from './pages/PagoProveedores';
import ProcesoRequerimientos from './pages/ProcesoRequerimientos';
import ContratoColaborador from './pages/ContratoColaborador';
import FinanzasCobranzas from './pages/FinanzasCobranzas';
import FinanzasPago from './pages/FinanzasPago';

function App() {
  const [state, setState] = useState({ login: false, password_changed: false, loading: true });

  const [globalState, setGlobalState] = useContext(AppContext);
  const [userData, setUserData] = useState(null);
  const [catalogData, setCatalogData] = useState(null);
  const navigate = useNavigate();
  const SESSION_DURATION = 32400000;


  const loadSessionData = async (user) => {
    try {
      const [personal, tipos, instituciones, agencias, perfiles, personal_administrativo] = await Promise.all([
        await UsuarioService.getPersonal(
          user.usuario_id,
          user.jefe_id,
          user.zonal_id,
          user.perfil_id
        ),
        CatalogoService.getTipos(),
        CatalogoService.getInstituciones(),
        CatalogoService.getAgencias(),
        CatalogoService.getPerfiles(),
        CatalogoService.getPersonalAdministrativo(),
      ]);

      await setGlobalState(prev => ({
        ...prev,
        user: {
          ...user,
          nombres: user.nombres,
          personal: personal,
        },
        catalogos: {
          tipos: tipos,
          instituciones: instituciones,
          agencias: agencias,
          perfiles: perfiles,
          personal_administrativo: personal_administrativo,
        },
      }));

      setState(prevState => ({ ...prevState, loading: false }));

    } catch (error) {
      console.error("Error al cargar los datos de la sesión:", error);
      handleLogout();
    }
  };

  useEffect(() => {
    const storedAuthData = JSON.parse(localStorage.getItem('authData'));
    let timer;
    if (storedAuthData && storedAuthData.token) {
      const loginTime = storedAuthData.loginTime || Date.now();
      const elapsedTime = Date.now() - loginTime;
      const remainingTime = SESSION_DURATION - elapsedTime;

      if (remainingTime > 0) {
        setState(prevState => ({
          ...prevState,
          login: true,
          password_changed: storedAuthData.user.password_changed,
          zonal_id: storedAuthData.user.zonal_id,
          jefe_id: storedAuthData.user.jefe_id,
          nombres: storedAuthData.user.nombres,
        }));
        loadSessionData(storedAuthData.user);
        timer = setTimeout(handleAutoLogout, remainingTime);
      } else {
        handleAutoLogout();
      }

    } else {
      setState(prevState => ({ ...prevState, loading: false }));
    }
  }, []);

  const handleLogin = async (passwordChanged) => {
    const storedAuthData = JSON.parse(localStorage.getItem('authData'));
    if (storedAuthData) {
      const authDataWithTime = {
        ...storedAuthData,
        loginTime: Date.now()
      };
      localStorage.setItem('authData', JSON.stringify(authDataWithTime));
      await loadSessionData(storedAuthData.user);
      setState(prevState => ({
        ...prevState,
        login: true,
        password_changed: passwordChanged,
      }));
    }
    if (passwordChanged === 1) {
      setState(prevState => ({ ...prevState, password_changed: true }));
    }
  };

  const handleLogout = async () => {
    try {
      await UsuarioService.logout();
    } catch (error) {
      console.error("Error al cerrar sesión en el servidor:", error);
    } finally {
      localStorage.removeItem('authData');
      setState({ login: false, password_changed: false, loading: false });
      setUserData(null);
      setCatalogData(null);
      navigate('/login');
    }
  };

  const handleAutoLogout = () => {
    localStorage.removeItem('authData');
    localStorage.removeItem('auth_token');
    setState({ login: false, password_changed: false, loading: false });
    alert('El tiempo máximo de su sesión ha expirado. Por favor, vuelva a iniciar sesión.');
    navigate('/login');
  };

  if (state.loading) {
    return <Loader />;
  }

  if (state.login === false) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          state.password_changed === true ? (
            <Home onLogout={handleLogout} />
          ) : (
            <ChangePassword onLogin={handleLogin} />
          )
        }
      />
      <Route path='/home' element={<Home onLogout={handleLogout} />} />
      <Route path='/agencias' element={<Agencias />} />
      <Route element={<DashboardLayout onLogout={handleLogout} />}>
        <Route path='/change_password' element={<ChangePassword />} />
        <Route path='/prospectos' element={<Prospectos />} />
        <Route path='/prospectos_tnp' element={<ProspectosTNP />} />
        <Route path='/reportes' element={<Reportes />} />
        <Route path='/usuarios' element={<Usuarios />} />
        <Route path='/revision' element={<EstadoRevision />} />
        <Route path='/gestion_prospectos' element={<GestionProspectos />} />
        <Route path='/seguimiento-boleta-prospecto' element={<SeguimientoBoletaProspecto />} />

        <Route path='/solicitudes_extra' element={<SolicitudesExtra />} />
        <Route path='/avances' element={<Avances />} />
        <Route path='/asignacion_metas' element={<AsignacionMetas />} />
        <Route path='/planilla' element={<Planilla />} />
        <Route path='/simulador_creditos' element={<SimuladorCreditos />} />
        <Route path='/inventario' element={<Inventario />} />
        <Route path='/cargo_pago' element={<CargoPago />} />
        <Route path='/administracion_cargo_pago' element={<AdministracionCargoPago />} />
        <Route path='/rh_administracion' element={<RHAdministracion />} />
        <Route path='/planilla_negocios' element={<PlanillaNegocios />} />
        <Route path='/rh_practicantes' element={<RhPracticantes />} />
        <Route path='/grafico_dashboard' element={<GraficoDashboard />} />
        <Route path='/dashboard_administracion' element={<DashboardAdministracion />} />
        <Route path='/graficos_colocaciones' element={<GraficosColocaciones />} />
        <Route path='/reporte_colaboradores' element={<ReporteColaboradores />} />
        <Route path='/gastos_totales' element={<GastosTotales />} />
        <Route path='/detalle_abc' element={<DetalleAbc />} />
        <Route path='/recibo_honorarios' element={<ReciboPorHonorarios />} />
        <Route path='/costos_directos' element={<CostosDirectos />} />
        <Route path='/resumen_final' element={<ResumenFinal />} />
        <Route path='/costos_abc' element={<CostosAbc />} />
        <Route path='/caja_flujo_datos' element={<CajaFlujoDatos />} />
        <Route path='/caja_financiero_movimiento' element={<CajaFinancieroMovimiento />} />
        <Route path='/caja_financiero_reporte' element={<CajaFinancieroReporte />} />
        <Route path='/caja_financiero_contabilidad' element={<CajaFinancieroContabilidad />} />
        <Route path='/gestion_pasajes' element={<Viaticos />} />
        <Route path="/solicitud_viaticos" element={<SolicitudViaticos />} />
        <Route path="/planilla_viaticos" element={<PlanillaViaticos />} />
        <Route path="/rendicion_viaticos" element={<RendicionViaticos />} />
        <Route path='/seguimiento-desembolsos' element={<SeguimientoDesembolsos />} />
        <Route path='/comisiones-desembolsos' element={<ComisionDesembolsos />} />
        <Route path='/control-poi' element={<ControlPoi />} />
        <Route path='/caja-financiero-presupuesto' element={<CajaFinancieroPresupuesto />} />
        <Route path='/firma_digital_convenios' element={<FirmaDigitalConvenios />} />
        <Route path='/perfil' element={<Perfil />} />
        <Route path='/notificaciones' element={<Notificaciones />} />
        <Route path='/gestion_correo' element={<GestionCorreo />} />
        <Route path='/sesiones_activas' element={<SesionesActivas />} />
        <Route path='/dispositivos_confianza' element={<DispositivosConfianza />} />
        <Route path='/gestion_servicio_sistemas' element={<GestionServicioSistemas />} />
        <Route path='/gestion_externo_sistemas' element={<GestionExternoSistemas />} />
        <Route path='/tareas_gantt' element={<TareasGantt />} />
        <Route path='/pagos_planilla' element={<PagosPlanilla />} />
        <Route path='/gestion_salida' element={<PapeletaSalida />} />
        <Route path='/descuento-tardanza' element={<DescuentoTardanza />} />
        <Route path='/capacitaciones' element={<Capacitaciones />} />
        <Route path='/asistencias' element={<Asistencias />} />
        <Route path='/induccion' element={<Induccion />} />
        <Route path='/practicantes' element={<Practicantes />} />
        <Route path='/ceso-culminacion-contrato' element={<Navigate to="/cesos" replace />} />
        <Route path='/cesos' element={<CesoCulminacionContrato />} />
        <Route path='/validacion-servicio' element={<ValidacionServicio />} />
        <Route path='/culminacion-vinculo-laboral' element={<Navigate to="/renuncias" replace />} />
        <Route path='/renuncias' element={<CulminacionVinculoLaboral />} />
        <Route path='/induccion_negocios' element={<InduccionNegocios />} />
        <Route path='/personal_reclutamiento' element={<PersonalReclutamiento />} />
        <Route path='/registro_memorandum' element={<Memorandum />} />
        <Route path='/sueldos-planilla' element={<SueldosPlanilla />} />
        <Route path='/restablecer_prospectos' element={<RestablecerProspectos />} />
        <Route path='/pago_detracciones' element={<PagoDetracciones />} />
        <Route path='/gestion_proveedores' element={<GestionProveedores />} />
        <Route path='/gestion_servicios_proveedor' element={<GestionServiciosProveedor />} />
        <Route path='/pago_proveedores' element={<PagoProveedores />} />
        <Route path='/proceso_requerimientos' element={<ProcesoRequerimientos />} />
        <Route path='/contrato_colaborador' element={<ContratoColaborador />} />
        <Route path='/finanzas-cobranzas' element={<FinanzasCobranzas />} />
        <Route path='/finanzas-pagos' element={<FinanzasPago />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Route>
    </Routes>
  );
}


const AppWrapper = () => (
  <AppProvider>
    <App />
  </AppProvider>
);

export default AppWrapper;
